export const V2_THEME_DEFAULT = 'dope_man_classic';

export const V2_THEMES = [
  {
    id: 'dope_man_classic',
    name: 'Dope Man Classic',
    description: 'The v1 street-green palette rebuilt for UI v2 and the current logo.',
    swatches: ['#050706', '#111610', '#b8ed4a', '#ff8a00', '#edf2e8'],
  },
  {
    id: 'back_alley',
    name: 'Back Alley',
    description: 'Warmer charcoal, dirty olive, tobacco brown, and muted amber.',
    swatches: ['#080705', '#17130e', '#9ead57', '#c78b45', '#ece4d5'],
  },
  {
    id: 'midnight_hustle',
    name: 'Midnight Hustle',
    description: 'Blue-black streets with cold green highlights for late-night dealing.',
    swatches: ['#05080d', '#0c151d', '#79d89b', '#73b9d6', '#e6eef5'],
  },
  {
    id: 'v1_dark',
    name: 'v1 Dark',
    description: 'A direct UI v2 translation of Stable UI v1’s Dark palette using its actual charcoal, lime, and muted text values.',
    swatches: ['#050607', '#0d1011', '#c8ed60', '#d97918', '#f1f3ed'],
  },
];

export const v2ThemeById = (id) => V2_THEMES.find((theme) => theme.id === id) || V2_THEMES[0];
